import { Button, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useContext } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { controller, endpoints } from "../../api/actions/api";
import { AppContext } from "../../App";
import { Input } from "../../controls";
import * as actions from "../../api/actions/pos";
import { IsEmptyObj } from "../../hooks/Method";

const CashInDrawer = (props) => {
  const { t } = useTranslation();  
  const { _get, setShow, _authUser } = props;
  const navigate = useNavigate();
  const { setCLoader } = useContext(AppContext);
  const [value, setValue] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = () => {
    if (value !== "") {
      localStorage.setItem(
        "posOpen",
        JSON.stringify({
          userId: _authUser.id,
          cashInDrawer: value,
          timeIn: new Date().toISOString(),
        })
      );
      setShow(false);
    } else setError(t("amountRequired"));
  };

  const handleLogout = () => {
    setCLoader(true);
    const onComplete = (res) => {
      setCLoader(false);
      navigate("/");
    };
    _get(
      endpoints.Auth + controller.Logout,
      actions.ActionType.Auth,
      onComplete
    );
  };

  return (
    <Grid container spacing={3} className="p-15 pt-40">
      <Grid item xs={12} className="tx-center">
        <Typography variant="h5" className="fs-22 gray-color fw-5 tx-upp">
          {t("cashInDrawer")}
        </Typography>
        <div className="bs-bottom mx-w-80 m-auto mt-10 mb-30" />
      </Grid>
      <Grid item xs={12}>
        <Input
          onChange={(e) => setValue(e.target.value)}
          label={t("amount")}
          name="amount"
          type="number"
          error={error}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} className="d-flex">
        <Button
          onClick={() => navigate("/")}
          className="btn-primary w-100pr mr-5"
          size="large"
        >
          {t("home")}
        </Button>
        <Button
          onClick={handleSubmit}
          className="btn-secondary w-100pr mr-5"
          size="large"
        >
          {t("submit")}
        </Button>
        <Button
          onClick={handleLogout}
          className="btn-error w-100pr"
          size="large"
        >
          {t("logout")}
        </Button>
      </Grid>
      {!IsEmptyObj(_authUser) && _authUser.role !== 3 && (
        <Grid item xs={12}></Grid>
      )}
    </Grid>
  );
};

const mapStateToProps = (state) => ({
  _authUser: state.pos.authUser,
});

const mapActionToProps = {
  _get: actions.get,
};

export default connect(mapStateToProps, mapActionToProps)(CashInDrawer);
